import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  inject,
  model,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { SelectComponent, SelectOptions } from '@shared/components';
import { APIService, DataService, ToastService } from '@core/services';
import { PatientService } from '@core/services/patient.service';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'ncp-problem-diagnosis-unknown-values',
  imports: [SelectComponent],
  templateUrl: './problem-diagnosis-unknown-values.component.html',
  styleUrl: './problem-diagnosis-unknown-values.component.scss',
})
export class ProblemDiagnosisUnknownValuesComponent implements OnInit, AfterViewInit {
  @ViewChild('select') select!: SelectComponent;
  protected readonly toastService = inject(ToastService);
  private readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  private apiService = inject(APIService);
  private patientService = inject(PatientService);
  private dataService = inject(DataService);
  protected readonly router = inject(Router);

  protected data = model<any>();
  protected unknownSelectOptions = signal<SelectOptions>({});

  protected form: FormGroup = new FormGroup({});

  protected _unknownValue?: number | string;

  get unknownValue() {
    return this._unknownValue;
  }

  set unknownValue(value: number | string | undefined) {
    this._unknownValue = value;
  }

  ngOnInit() {
    this.unknownSelectOptions.set(
      new SelectOptions({
        label: {
          text: 'information_problems',
          class: 'm-0 me-2',
        },
        values: [
          { id: 0, value: 'has_problems' },
          { id: 11, value: 'no_info_problems' },
          { id: 10, value: 'no_known_problems' },
        ],
        model: this.unknownValue,
        onModelChange: this.onUnknownValueChange,
        disabled:
          !(
            this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit'
          ) ||
          (this.data()?.tblOptions() &&
            this.data()?.tblOptions().data &&
            (this.data()?.tblOptions().data!.length || [].length) > 0),
      })
    );
    this.setInitialUnknownValue();
  }

  ngAfterViewInit(): void {}

  setInitialUnknownValue = () => {
    if (
      this.data().tblOptions() &&
      this.data()?.tblOptions().data &&
      this.data()?.tblOptions().data.length > 0 &&
      this.data()?.tblOptions().otherData &&
      this.data()?.tblOptions().otherData.length === 0
    ) {
      this.unknownValue = 0;
    } else {
      this.unknownValue =
        this.data().tblOptions() &&
        this.data()?.tblOptions().data &&
        this.data()?.tblOptions().data.length === 0 &&
        this.data()?.tblOptions().otherData &&
        this.data()?.tblOptions().otherData.length === 1
          ? this.data()?.tblOptions().otherData[0].coding_id
          : undefined;
      if (this.data()?.extra?.componentInstance) {
        this.data().extra.componentInstance.btnPDOptions().disabled = true;
      }
    }
    this.unknownSelectOptions().model = this.unknownValue;
  };

  protected onUnknownValueChange = (value?: number | string) => {
    if (value && value !== 0) {
      if (this.data()?.extra?.componentInstance) {
        this.data().extra.componentInstance.btnPDOptions().isLoading = true;
      }
      this.apiService
        .call({
          path: '/unknown-values',
          headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
          body: {
            status: 1,
            coding_id: value.toString(),
            epSOS_OID: '1.3.6.1.4.1.12559.11.10.1.3.1.42.50',
            version_id: this.patientService.patient?.version?.new || -1,
          },
        })
        ?.subscribe((res) => {
          if (res && res.status && res.status === 1) {
            this.select.blur();
            if (this.data()?.extra?.componentInstance) {
              this.data().extra.componentInstance.btnPDOptions().disabled =
                value === 11 || value === 10;
              this.data().extra.componentInstance.btnPDOptions().isLoading = false;
            }
            this.unknownValue = value;
          }
        });
    } else {
      this.select.blur();
      if (this.data()?.extra?.componentInstance) {
        this.data().extra.componentInstance.btnPDOptions().disabled = false;
      }
      this.unknownValue = value;
    }
  };
}
